import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import Table, { Row } from 'components/ReusableComponents/Table'
import useCopyText from 'hooks/useCopyText'
import moment from 'moment'

import styles from './BookingRow.module.css'

const formatDate = date => (date ? moment(date).format('MM/DD/YYYY') : '-')

const Cell = ({ children, ...props }) => (
  <Table.Cell {...props} className={styles.cell}>
    <span className={styles.cellInner}>{children}</span>
  </Table.Cell>
)

const BookingRow = ({
  bookingDate,
  bookedBy,
  bookingId,
  bookingSource,
  checkIn,
  checkOut,
  totalRate,
  rateCode,
  trackingInfo,
  companyName,
  roomNumber,
  roomBookingCode,
  confirmationCode,
  fullName,
  state,
  city,
  phone,
  email = ''
}) => {
  const copy = useCopyText()

  return (
    <Row>
      <Cell>{bookingDate ? moment(bookingDate).format('MM/DD/YYYY') : '-'}</Cell>
      <Cell>{bookedBy}</Cell>
      <Cell>{fullName}</Cell>
      <Cell>{phone}</Cell>
      <Cell>{email?.toLowerCase()}</Cell>
      <Cell>
        {city}, {state}
      </Cell>
      <Cell>{bookingSource}</Cell>
      <Cell>{formatDate(checkIn)}</Cell>
      <Cell>{formatDate(checkOut)}</Cell>
      <Cell>${totalRate?.toFixed(2)}</Cell>
      <Cell>{rateCode}</Cell>
      <Cell>{trackingInfo}</Cell>
      <Cell>{companyName}</Cell>
      <Cell>
        {roomBookingCode} {roomNumber}
      </Cell>
      <Table.Cell className={styles.copyCell}>
        <button className={styles.copyButton} onClick={() => copy(bookingId)}>
          <CopyIcon />
        </button>
        {bookingId}
      </Table.Cell>
      <Table.Cell className={styles.copyCell}>
        <button className={styles.copyButton} onClick={() => copy(confirmationCode)}>
          <CopyIcon />
        </button>
        {confirmationCode}
      </Table.Cell>
    </Row>
  )
}

export default BookingRow
